import { type ReactNode } from 'react';
import NotesSidebar from '../NotesSidebar';
import SecurityProvider from '@/modules/Security';
import Header from '@/components/Header';
export interface LayoutProps {
  headerContent?: ReactNode;
  sidebarContent?: ReactNode;
  children: ReactNode;
}

const Layout = ({ headerContent, sidebarContent, children }: LayoutProps) => {
  return (
    <SecurityProvider>
      <Header>{headerContent}</Header>
      <main className="flex flex-1">
        {sidebarContent && <NotesSidebar>{sidebarContent}</NotesSidebar>}
        <section className="flex-1">{children}</section>
      </main>
    </SecurityProvider>
  );
};

export default Layout;
